import { render, staticRenderFns } from "./DigitalClinicsFeedbackModal.vue?vue&type=template&id=5c8818bc"
import script from "./DigitalClinicsFeedbackModal.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsFeedbackModal.vue?vue&type=style&index=0&id=5c8818bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports